@if (banner.hasError()) {
  <div
    class="global-loading-banner global-loading-banner--error px-4 py-2"
    role="alert"
  >
    <span class="global-loading-banner__text font-medium text-sm">{{ banner.failureMessage() }}</span>
  </div>
} @else if (banner.isLoading()) {
  <div
    class="global-loading-banner global-loading-banner--loading px-4 py-2 flex align-items-center gap-2"
    aria-live="polite"
    aria-busy="true"
  >
    <p-progressSpinner strokeWidth="3" styleClass="global-loading-banner-spinner" ariaLabel="Cargando"></p-progressSpinner>
    <span class="global-loading-banner__text text-sm font-medium">Cargando</span>
  </div>
}
